import useTheme from '@hero/branding/theme';
import { IconComponentProps } from '@hero/ui-kit/types';
import React from 'react';

const SparklesIcon: React.FC<IconComponentProps> = ({
    type = 'utility',
    size = 'regular',
    disabled = false,
    styles,
    color = 'currentColor',
    ...rest
}) => {
    const { sizing } = useTheme();
    const sizePx = sizing.widths.icon[size];

    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            width={sizePx}
            height={sizePx}
            style={styles}
            {...rest}
        >
            <path
                fill={color}
                d="M10.5 2C10.5 6.14 13.86 9.5 18 9.5C13.86 9.5 10.5 12.86 10.5 17C10.5 12.86 7.14 9.5 3 9.5C7.14 9.5 10.5 6.14 10.5 2Z"
            />
            <path
                fill={color}
                d="M18 13C18 15.21 19.79 17 22 17C19.79 17 18 18.79 18 21C18 18.79 16.21 17 14 17C16.21 17 18 15.21 18 13Z"
            />
        </svg>
    );
};

export default SparklesIcon;
